import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=bdda1ea4&scoped=true&"
import script from "./Tabs.vue?vue&type=script&lang=js&"
export * from "./Tabs.vue?vue&type=script&lang=js&"
import style0 from "./Tabs.vue?vue&type=style&index=0&id=bdda1ea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdda1ea4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdda1ea4')) {
      api.createRecord('bdda1ea4', component.options)
    } else {
      api.reload('bdda1ea4', component.options)
    }
    module.hot.accept("./Tabs.vue?vue&type=template&id=bdda1ea4&scoped=true&", function () {
      api.rerender('bdda1ea4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Tabs.vue"
export default component.exports